import React from "react";
import idsLogo from "assets/images/website/ids-logo.svg";
import fintechLogo from "assets/images/website/fintech-logo.svg";
import vanriseLogo from "assets/images/website/vanrise-logo.png";
import softHubLogo from "assets/images/website/softhub-logo.svg";

const Partners: React.FC = () => {
  return (
    <section className="bg-white/70 dark:bg-secondary-900/40">
      <div className="text-center py-2">
        <h2 className="text-2xl font-bold text-secondary-600 dark:text-white mt-7">Trusted by industry leaders</h2>
      </div>
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-8 py-12 sm:py-16">
            <div className="relative overflow-hidden">
          <div className="flex gap-8 md:gap-[116px] whitespace-nowrap animate-scroll sm:animate-scrollSm md:animate-scrollMd lg:animate-scrollLg">
            <img
              src={idsLogo}
              className="h-16 sm:h-20 md:h-22 lg:h-24 w-auto flex-shrink-0 grayscale opacity-40"
            />
            <img
              src={softHubLogo}
              className="h-16 sm:h-20 md:h-22 lg:h-24 w-auto flex-shrink-0 grayscale opacity-40"
            />
            <img
              src={vanriseLogo}
              className="h-16 sm:h-20 md:h-22 lg:h-24 w-auto flex-shrink-0 grayscale opacity-40"
            />
            <img
              src={fintechLogo}
              className="h-16 sm:h-20 md:h-22 lg:h-24 w-auto flex-shrink-0 grayscale opacity-40"
            />
            <img
              src={idsLogo}
              className="h-16 sm:h-20 md:h-22 lg:h-24 w-auto flex-shrink-0 grayscale opacity-40"
            />
            <img
              src={softHubLogo}
              className="h-16 sm:h-20 md:h-22 lg:h-24 w-auto flex-shrink-0 grayscale opacity-40"
            />

            {/*duplicate for seamless loop */}
            <img
              src={idsLogo}
              className="h-16 sm:h-20 md:h-22 lg:h-24 w-auto flex-shrink-0 grayscale opacity-40"
            />
            <img
              src={softHubLogo}
              className="h-16 sm:h-20 md:h-22 lg:h-24 w-auto flex-shrink-0 grayscale opacity-40"
            />
            <img
              src={vanriseLogo}
              className="h-16 sm:h-20 md:h-22 lg:h-24 w-auto flex-shrink-0 grayscale opacity-40"
            />
            <img
              src={fintechLogo}
              className="h-16 sm:h-20 md:h-22 lg:h-24 w-auto flex-shrink-0 grayscale opacity-40"
            />
            <img
              src={idsLogo}
              className="h-16 sm:h-20 md:h-22 lg:h-24 w-auto flex-shrink-0 grayscale opacity-40"
            />
            <img
              src={softHubLogo}
              className="h-16 sm:h-20 md:h-22 lg:h-24 w-auto flex-shrink-0 grayscale opacity-40"
            />
        </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
